import useAppRouter from './useAppRouter'

const useGetAppRealPath = () => {
  const router = useAppRouter()
  return () => router.asPath
}
export default useGetAppRealPath
